export default __webpack_public_path__ + "static/media/meetra_main_logo.a6d8704b.png";